import dayjs from 'dayjs';

const TIMER_OFF_DATE_FORMAT = 'ddd, MMM DD, YYYY h:mm A';

export function formatTimerOffMessage(nextPowerOn: Date | null, options: { playbackRunning: boolean }): string {
	const formatted = nextPowerOn ? dayjs(nextPowerOn).format(TIMER_OFF_DATE_FORMAT) : null;
	if (options.playbackRunning) {
		if (formatted) {
			return `The display is currently powered off by its timer settings until ${formatted}, but playback is running.`;
		}
		return 'The display is currently powered off by its timer settings, but playback is running.';
	}
	if (formatted) {
		return `The display is currently powered off by its timer settings. Playback is stopped until ${formatted}.`;
	}
	return 'The display is currently powered off by its timer settings. Playback is stopped.';
}
